import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CadastroPadraoComponent } from '../../../shared/cadastro-padrao/cadastro-padrao.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../../services/message.service';
import { UtilFunctions } from '../../../general/utils-service';
import { StorageFunctions } from '../../../general/storage';
import { Location } from '@angular/common';
import { markFormGroupTouched } from '../../../general/utils';
import { UnidadesEmpresaParametrosService } from '../../../services/unidades-empresa-parametros.service';

@Component({
  selector: 'app-itens-composicao',
  templateUrl: './itens-composicao.component.html',
  styleUrls: ['./itens-composicao.component.css']
})
export class ItensComposicaoComponent extends CadastroPadraoComponent implements OnInit, AfterViewInit {

  constructor(
    route: ActivatedRoute,
    utilsFunction: UtilFunctions,
    message: MessageService,
    storage: StorageFunctions,
    location: Location,
    private parametrosService: UnidadesEmpresaParametrosService
  ) {
    super(route, utilsFunction, message, storage, location);
  }

  @Output('') formFinished = new EventEmitter<any>();
  @Input('itemEdicao') itemEdicao;
  @Input('produtoID') produtoID = null;
  composicaoForm: FormGroup;
  loading = [];

  optionsQuantidade = {
    prefix: '', precision: 2
  };

  ngOnInit() {
    this.parametrosService.getParametrosGerais().subscribe(params => {
      if (params.casasDecimaisQuantidade) {
        this.optionsQuantidade.precision = params.casasDecimaisQuantidade.toString();
      }
    })

    this.composicaoForm = new FormGroup({
      id: new FormControl(this.itemEdicao ? this.itemEdicao.id : 0),
      itemFilhoID: new FormControl((this.itemEdicao ? this.itemEdicao.itemFilhoID : null), [Validators.required]),
      descricaoItem: new FormControl(this.itemEdicao ? this.itemEdicao.descricaoItem : null),
      quantidade: new FormControl((this.itemEdicao ? this.itemEdicao.quantidade : null), [Validators.required])
    });
  }

  ngAfterViewInit() {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    })
  }

  itemChanged(item) {
    if (item) {
      this.composicaoForm.get('descricaoItem').setValue(item.nome);
    }
  }

  salvarItem() {
    markFormGroupTouched(this.composicaoForm);

    if (this.composicaoForm.valid) {
      this.formFinished.emit(this.composicaoForm.value);
    }
  }

  cancelarDigitacao() {
    this.formFinished.emit(null);
  }
}
